import * as Sentry from "@sentry/react";
import { scrubPhi } from "./phi-scrubber";

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.warn("[Sentry] No DSN configured, skipping initialization");
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tunnel: "/api/sentry-tunnel",
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA ?? "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [/^\/api\//, import.meta.env.VITE_API_URL],
    beforeSend: (event) => {
      if (event.extra)
        event.extra = scrubPhi(event.extra) as typeof event.extra;
      if (event.contexts)
        event.contexts = scrubPhi(event.contexts) as typeof event.contexts;
      return event;
    },
  });
}

export function getTraceId(): string | undefined {
  return Sentry.getActiveSpan()?.spanContext().traceId;
}

export function setSentryUser(userId: string, orgId?: string): void {
  Sentry.setUser({ id: userId });
  if (orgId) Sentry.setTag("orgId", orgId);
}

export function clearSentryUser(): void {
  Sentry.setUser(null);
}
